import { Component, input, output, signal } from '@angular/core';
import { AdminIconComponent } from '../../../../../../shared/admin/admin-icon.component';

@Component({
  selector: 'app-release-image-gallery',
  standalone: true,
  imports: [AdminIconComponent],
  templateUrl: './release-image-gallery.component.html',
  styleUrl: './release-image-gallery.component.scss',
})
export class ReleaseImageGalleryComponent {
  readonly imageUrls = input<string[]>([]);

  readonly lightboxUrl = signal<string | null>(null);

  open(url: string): void {
    this.lightboxUrl.set(url);
  }

  close(): void {
    this.lightboxUrl.set(null);
  }
}
